"use strict";

var _templateObject, _templateObject2;
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.Tree = void 0;
var _tsRes = require("ts-res"),
  _kameleoonError = require("../kameleoonError"),
  _node = require("./node"),
  _types = require("./types"),
  _logging = require("../logging");
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var Tree = /*#__PURE__*/function () {
  function Tree(a) {
    var _this = this;
    _classCallCheck(this, Tree);
    _defineProperty(this, "tree", void 0), _defineProperty(this, "error", null), _defineProperty(this, "targetingTypes", new Set()), _logging.KameleoonLogger.debug(_templateObject || (_templateObject = _taggedTemplateLiteral(["CALL: new Tree(segment: ", ")"])), a);
    var _this$flattenSegment = this.flattenSegment(a),
      b = _this$flattenSegment.nestedConditions,
      c = _this$flattenSegment.topLevelOperators,
      d = b.map(function (a) {
        var b = a.conditions,
          c = a.operators;
        var d = b.map(function (a) {
          return _this.targetingTypes.add(a.targetingType), new _node.Node(a);
        });
        return _this.buildTree(d, c);
      });
    this.tree = this.buildTree(d, c), _logging.KameleoonLogger.debug(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["RETURN: new Tree(segment: ", ")"])), a);
  }
  return _createClass(Tree, [{
    key: "evaluate",
    value: function evaluate(a) {
      var b = this.evaluateNode(this.tree, a);
      return this.error ? (0, _tsRes.Err)(this.error) : (0, _tsRes.Ok)(b);
    }
  }, {
    key: "hasTargetingType",
    value: function hasTargetingType(a) {
      return this.targetingTypes.has(a);
    }
  }, {
    key: "evaluateNode",
    value: function evaluateNode(a, b) {
      if (this.isLeafNode(a)) {
        if (a.error) return a.error.type === _kameleoonError.KameleoonException.TargetingCondition;
        var c = a.value.evaluate(b);
        return c.ok ? a.inverse ? !c.data : c.data : (this.error = c.error, !1);
      }
      if (this.isNonLeafNode(a)) switch (a.value) {
        case _types.Operator.And:
          return this.evaluateNode(a.left, b) && this.evaluateNode(a.right, b);
        case _types.Operator.Or:
          return this.evaluateNode(a.left, b) || this.evaluateNode(a.right, b);
        default:
      }
      return !1;
    }
  }, {
    key: "isLeafNode",
    value: function isLeafNode(a) {
      return !!!(a.left && a.right);
    }
  }, {
    key: "isNonLeafNode",
    value: function isNonLeafNode(a) {
      return !!(a.left && a.right && (a.value === _types.Operator.Or || a.value === _types.Operator.And));
    }
  }, {
    key: "buildTree",
    value: function buildTree(a, b) {
      if (1 === a.length) return a[0];
      var _iterator = _createForOfIteratorHelper(b),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var c = _step.value;
          var _b = a.shift(),
            d = a.shift(),
            e = new _node.Node(c, _b, d);
          a.unshift(e);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return a[0];
    }
  }, {
    key: "flattenSegment",
    value: function flattenSegment(a) {
      var _this2 = this;
      var _a$conditionsData = a.conditionsData,
        b = _a$conditionsData.firstLevel,
        c = _a$conditionsData.firstLevelOrOperators,
        d = [];
      return b.forEach(function (a) {
        var b = a.conditions,
          c = a.orOperators,
          e = {
            operators: _this2.convertOperators(c),
            conditions: b
          };
        d.push(e);
      }), {
        topLevelOperators: this.convertOperators(c),
        nestedConditions: d
      };
    }
  }, {
    key: "convertOperators",
    value: function convertOperators(a) {
      return a.map(function (a) {
        return a ? _types.Operator.Or : _types.Operator.And;
      });
    }
  }]);
}();
exports.Tree = Tree;